
import { Component } from '@angular/core';
import { AppData } from '../../../app-data';
import { SubCategory } from '../../../model/api/assets/sub-category';
import { Param } from '../../../model/common/param';
import { GenericTableList } from '../../generic/generic.table.list';

@Component({
    selector: 'app-sub-category-list',
    templateUrl: '../../generic/generic.table.list.html'
})
export class SubCategoryListComponent extends GenericTableList<SubCategory, number> {
    private listName: string = 'SUBCATEGORIES';

    constructor() {
        super('name', 'asc', '');
        this.columns = AppData.ColumnDefinitions[this.listName];
    }

    public refresh(filters: Array<Param>) {
        this.columns = AppData.ColumnDefinitions[this.listName];
        super.refresh(filters);
    }
}